import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select as MuiSelect,
  SelectProps as MuiSelectProps
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import styles from './Select.module.scss';
import classnames from 'classnames/bind';

const CN = 'select';
const componentClassName= `${CN}--component`;
const cx = classnames.bind(styles);

export interface SelectOption {
  label: string,
  value: string | number,
}

export type SelectProps = MuiSelectProps<string> & {
  options?: SelectOption[],
  helperText?: string,
  shrinkLabel?: boolean,
  capitalize?: boolean,
  componentClassName?: string,
}

export const Select: React.FC<SelectProps> = ({
  className,
  options,
  children,
  label,
  error,
  required,
  helperText,
  shrinkLabel,
  capitalize,
  componentClassName: receivedComponentCN,
  ...selectProps
}) => (
  <FormControl required={ required } error={ error } className={ cx(CN, className) }>
    {label && <InputLabel shrink={ shrinkLabel } >{label}</InputLabel>}
    <MuiSelect
      className={ cx(componentClassName, receivedComponentCN) }
      IconComponent= { KeyboardArrowDownIcon }
      input={ <OutlinedInput label={ label } notched={ shrinkLabel } /> }
      { ...selectProps }
    >
      {options ? options.map((option: SelectOption) => (
        <MenuItem
          key={ option.value }
          value={ option.value }
        >
          { capitalize ? option.label.toUpperCase() : option.label }
        </MenuItem>
      )) : children}
    </MuiSelect>
    {helperText && <FormHelperText>{ helperText }</FormHelperText>}
  </FormControl>
);
